import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import { subjectTeacherListSvc, getClassListSvc, getSectionListSvc } from './manualAllocationSvc';
import ManualAllocationTable from './manualAllocationTbl';


const ManualAllocationSlider = (props) => {
    const { closeSlider } = props;

    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);

    const [lstCls, setLstCls] = useState([]);
    const [clsId, setClsId] = useState(null);
    const [lstSection, setLstSection] = useState([]);
    const [selSectionId, setSelSectionId] = useState(null);
    const [randNo, setRandNo] = useState(0);
    const [lstSub, setLstSub] = useState([]);
    const [syllabusId, setSyllabusId] = useState(0);

    const [flgUpdateTimetable, setFlgUpdateTimetable] = useState(false)
    const [flgAvoidClash, setFlgAvoidClash] = useState(false)



    useEffect(() => {
        // console.log("ManualAllocationSlider called");
        setClass();
    }, []);


    const getSubjectTeacherList = (pSectionId) => {
        // console.log("getSubjectTeacherList called");
        setEditLoader("block");
        setEditOpacity(0.5);
        subjectTeacherListSvc(pSectionId, subjectTeacherListResponse);
    }

    const subjectTeacherListResponse = (data) => {
        // console.log("subjectTeacherListResponse called, data", data);
        if (data.status === "Success") {
            setLstSub(data.lstSub);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    function setClass() {
        getClassListSvc(handleClassResponse);
    }

    function handleClassResponse(data) {
        var obj = data;
        if (obj.SvcStatus == 'Success') {
            setLstCls(obj.lstCls);
        } else if (obj.SvcStatus == 'Failure') {
            if (obj.SvcMsg === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.SvcMsg === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.SvcMsg);
            }
        } else {
            toast.error("Service failed " + obj.SvcMsg);
        }
    }

    function handleClsChange(e) {
        // console.log("handleClassChange() called, parameter passed vClsId = e.target.value", e.target.value);

        var vClsId = e.target.value;
        setClsId(vClsId)
        setSelSectionId(0)
        setSection(vClsId);
        generateRandomNo();
    }

    function setSection(clsId) {
        getSectionListSvc(handleSectionResponse, clsId);
    }

    function handleSectionResponse(data) {
        var obj = data;
        if (obj.SvcStatus == 'Success') {
            setLstSection(obj.lstClassSection);
            // console.log("obj in handle SectionResponse", obj);
            // console.log("obj.lstClassSection", obj.lstClassSection);
            if (obj.lstClassSection && obj.lstClassSection.length > 0) {
                changeSection(obj.lstClassSection[0]);
            }
        } else if (obj.SvcStatus == 'Failure') {
            if (obj.SvcMsg === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.SvcMsg === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.SvcMsg);
            }
        } else {
            toast.error("Service failed " + obj.SvcMsg);
        }
    }

    function changeSection(pSection) {
        // console.log("changeSection called, pSection", pSection);
        setSelSectionId(pSection.sectionId);
        getSubjectTeacherList(pSection.sectionId);
        setSyllabusId(pSection.syllabusId);
        generateRandomNo()
    }
    function generateRandomNo() {
        var lRandNo = Math.floor(Math.random() * 999999);
        // console.log(lRandNo)
        setRandNo(lRandNo)
    }





    return (
        <div >
            <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove "
                style={{
                    cursor: (editLoader === "none") ? 'pointer' : 'none',
                    pointerEvents: (editLoader === "none") ? 'auto' : 'none',
                    opacity: editOpacity
                }}>
                <div className="col-sm-12 col-md-12 padding-remove"
                    style={{ width: '94%', margin: '3% ', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
                    <form
                        id="editManualAllocationForm"
                        className='form form-horizontal'
                        style={{ height: "90vh", maxHeight: "600px", overflowX: 'hidden', padding: "20px 20px 5px 20px", }}
                    >
                        <div className="col-md-12 col-sm-12 padding-remove">
                            <div className="row">
                                <div className="col-sm-3 padding-remove" style={{ left: '4%', paddingRight: 0 }}>
                                    <div className="form-group col-sm-9 padding-remove">
                                        <select autoComplete="off" name="classId" id="classesCmb"
                                            type="text" className="form-control"
                                            onChange={handleClsChange}
                                        >
                                            <option value="0" >Class</option>
                                            {lstCls.map((obj) => (
                                                <option value={obj.classId}
                                                    key={obj.classId} id={obj.classId} >{obj.classLabel}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-9 padding-remove">
                                    <div className="tab form-group padding">
                                        {lstSection.map((obj) => {
                                            var isSelected = obj.sectionId === selSectionId;
                                            return <div style={{
                                                height: 34, display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }} className={isSelected ? "sellected" : ""} onClick={(e) => changeSection(obj)} key={obj.sectionId}>
                                                <span hidden>{obj.sectionId}</span>
                                                <span>{obj.section}</span>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="control-label text-left col-sm-3" style={{ width: '20.9%' }}>Update Timetable</label>
                                <div className="col-sm-1 form-group">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={flgUpdateTimetable}
                                        onChange={(e) => setFlgUpdateTimetable(e.target.checked)}
                                        id="cbox_updateTimetable"
                                    />
                                </div>
                                <label className="control-label text-left col-sm-2" style={{ left:"2%", width: "16%" }}>Avoid Clash</label>
                                <div className="col-sm-1 form-group">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={flgAvoidClash}
                                        onChange={(e) => setFlgAvoidClash(e.target.checked)}
                                        id="cbox_avoid_clash"
                                    />
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-12 padding-remove">
                                <ManualAllocationTable
                                    lstSub={lstSub}
                                    syllabusId={syllabusId}
                                    clsId={clsId}
                                    sectionId={selSectionId}
                                    setEditLoader={setEditLoader}
                                    setEditOpacity={setEditOpacity}
                                    flgUpdateTimetable={flgUpdateTimetable}
                                    flgAvoidClash={flgAvoidClash}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    );
}

export default ManualAllocationSlider;

